let _navigate = null;

export function setNavigator(navigate) {
  _navigate = navigate;
}

export function go(path, options) {
  if (!_navigate) {
    console.warn('Navigation service not initialized yet.');
    return;
  }
  _navigate(path, options);
}
